import { createApiCall } from 'lib/base';

export const OAUTH2_GET_TOKEN = 'DASHBOARD/OAUTH2_GET_TOKEN';

export const apiCall = createApiCall(OAUTH2_GET_TOKEN, (payload: any) => ({
  endpoint: `/api/admin/auth/get-token`,
  method: 'POST',
  body: payload,
  // The login page shows the error (e.g. 403 for a non-staff account).
  skipDefaultErrorHandling: true,
}));

export default apiCall;

// Whether the stored staff session (X-Staff-Session) is still live for the
// Google account just signed in. The page handles every error.
export const checkAccessApi = createApiCall<void>('CHECK_ACCESS', () => ({
  endpoint: `/api/admin/auth/check-access`,
  method: 'POST',
  body: {},
  skipDefaultErrorHandling: true,
}));
